import { Controller } from '@hotwired/stimulus'

const PREMIUM_PROGRAM_CODES = ['GOLD', 'ADVANCE', 'SELECT', 'CONCIERGE']
const PREMIUM_PROGRAM_LABELS = [
  'premium',
  'advance',
  'select',
  'gold',
  'concierge',
]

export default class extends Controller {
  static targets = [
    'programLevelCode',
    'programLevelLabel',
    'seniorityWrapper',
    'seniorityInput',
  ]

  connect() {
    // Run after other controllers initialize preselected values.
    requestAnimationFrame(() => this.syncVisibility())
  }

  programChanged() {
    this.syncVisibility()
  }

  syncVisibility() {
    if (!this.hasSeniorityWrapperTarget) return

    const shouldShow = this.premiumOrSelectSelected()

    this.seniorityWrapperTarget.classList.toggle('hidden', !shouldShow)

    if (this.hasSeniorityInputTarget) {
      this.seniorityInputTarget.required = shouldShow
    }
  }

  premiumOrSelectSelected() {
    if (this.hasProgramLevelCodeTarget) {
      const selectedCode = this.programLevelCodeTarget.value
      if (PREMIUM_PROGRAM_CODES.includes(selectedCode)) {
        return true
      }
    }

    if (this.hasProgramLevelLabelTarget) {
      const selectedText = this.programLevelLabelTarget.value
        .toString()
        .toLowerCase()
      return PREMIUM_PROGRAM_LABELS.some((keyword) =>
        selectedText.includes(keyword),
      )
    }

    return false
  }
}
